import PropTypes from 'prop-types';
import React from 'react';

class ErrorMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { message } = this.props;
    return (
      <>
        <h3 className="app-title">
          Cloud initialisation failed
        </h3>
        <p className="app-status">
          Try again by launching from the Hub. If you continue to encounter problems, check our <a className="app-link" href="https://kb.vu.city/home/">knowledge base</a> and get in touch with our support team
        </p>
        <br />
        <p className="app-status">{message}</p>
      </>
    );
  }
}

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

ErrorMessage.defaultProps = {
  message: '',
};

export default ErrorMessage;
